<template>
  <div>
    <ActivateList :_type="$data._corporateType.industry.value" />
  </div>
</template>

<script>
import ActivateList from './ActivateList'
export default {
  components: {
    ActivateList
  },
  name: 'ActivateIndustries'
}
</script>